var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.offersVisible)?_c('Card',{attrs:{"title":_vm.$t('Offers')}},[_c('CardSection',[_c('FormLayout',[_c('FormLayoutGroup',[(_vm.inactiveOffers.length)?_c('Select',{attrs:{"placeholder":_vm.$t('Choose an offer'),"options":_vm.inactiveOffers},model:{value:(_vm.quickSelectedId),callback:function ($$v) {_vm.quickSelectedId=$$v},expression:"quickSelectedId"}}):_vm._e(),_c('Button',{attrs:{"disabled":!_vm.quickSelectedId || !_vm.offersVisible},on:{"click":_vm.addSelectedId}},[_vm._v(_vm._s(_vm.$t('Add to Segment')))])],1)],1)],1),(_vm.activeOffers.length)?_c('CardSection',{attrs:{"title":_vm.$t('Active in Segment')}},[_c('DataTable',{attrs:{"columns":[
        {
          key: 'displayText',
          label: _vm.$t('Offer'),
          sortable: true
        },
        { 
          key: 'code',
          label: _vm.$t('Code')
        },
        { 
          key: 'status',
          label: _vm.$t('Status')
        },
        {
          key: 'variant',
          label: _vm.$t('Variant')
        }
      ],"row-actions":[
        {
          label: _vm.$t('Go to offer'),
          onAction: function (row) { return _vm.goToOffer(row.id); }
        },
        {
          label: _vm.$t('Remove'),
          onAction: function (row) { return _vm.removeById(row.id); }
        }
      ],"rows":_vm.activeOffers,"sort":_vm.sortBy},on:{"update:sort":function($event){_vm.sortBy=$event}},scopedSlots:_vm._u([{key:"col:displayText",fn:function(ref){
      var row = ref.row;
return [_vm._v("\n        "+_vm._s(row.displayText)+"\n        "),(row.listSummary)?_c('Caption',[_vm._v(_vm._s(row.listSummary))]):_vm._e()]}},{key:"col:status",fn:function(ref){
      var row = ref.row;
return [(!row.isDisabled)?_c('Badge',{attrs:{"status":"success"}},[_vm._v(_vm._s(_vm.$t('Active')))]):(row.isDisabled)?_c('Badge',{attrs:{"status":"warning"}},[_vm._v(_vm._s(_vm.$t('Inactive')))]):_vm._e(),_c('div',[(row.status === 'runOut')?_c('Badge',{attrs:{"status":"attention"}},[_vm._v(_vm._s(_vm.$t('campaignEdit.offer.Low Codes')))]):_vm._e()],1),_c('div',[(_vm.outsideValidityPeriod(row))?_c('Badge',{attrs:{"status":"info"}},[_vm._v(_vm._s(_vm.$t('campaignEdit.segment.Outside validity period')))]):_vm._e()],1)]}},{key:"col:code",fn:function(ref){
      var row = ref.row;
return [(row.promoType === 'file')?_c('Badge',{attrs:{"status":"info"}},[_vm._v(_vm._s(_vm.$t('Multiple')))]):(row.promoType === 'code')?[_vm._v(_vm._s(row.code))]:_vm._e()]}}],null,false,2462477886)})],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }